import React, { ReactNode } from 'react';
import { Skeleton } from '@chakra-ui/react';
import { Spinner } from 'components/Spinner';

type LoadingContainerProps = {
  isLoaded: boolean;
  children?: ReactNode[] | ReactNode;
  hasSpinner?: boolean;
};

export const LoadingContainer = ({
  isLoaded,
  children,
  hasSpinner,
}: LoadingContainerProps): JSX.Element => {
  return hasSpinner && !isLoaded ? (
    <Spinner isFixed delay={300} />
  ) : (
    <Skeleton
      isLoaded={isLoaded}
      startColor="#f8f8f8"
      endColor="rgba(248, 248, 248, 0.7)"
      style={{
        borderRadius: 10,
      }}
    >
      {children}
    </Skeleton>
  );
};
